import { useContext } from 'react'
import { SearchContext } from '../containers/contexts/search'

export const useTransferSearch = () => {
  const { transferSearchState, searchTransfers } = useContext(SearchContext)
  return { transferSearchState, searchTransfers }
}
